import React, { useEffect, useRef } from "react";
import CommentItem from "./CommentItem";
import { debounce } from "lodash";
import "./styles.scss";

const CommentList = props => {
    const {
        comments,
        objectType,
        objectId,
        openEmailHistory,
        setDispatch,
        isDisabled,
        onStateUpdate,
        onDeleteComment,
    } = props;
    const listRef = useRef(null);

    useEffect(() => {
        const listElement = listRef.current;
        if (!listElement) return;

        const adjustKebabButtonPosition = () => {
            const hasScrollbar = listElement.scrollHeight > listElement.clientHeight;
            listRef.current.classList.toggle("comment-item-has-scrollbar", hasScrollbar);
        };

        const debouncedAdjust = debounce(adjustKebabButtonPosition, 100);

        const resizeObserver = new ResizeObserver(debouncedAdjust);

        resizeObserver.observe(listElement);

        adjustKebabButtonPosition();

        return () => {
            resizeObserver.disconnect();
            debouncedAdjust.cancel();
        };
    }, []);

    return (
        <div className="comment-list" ref={listRef}>
            {comments.length > 0 &&
                comments.map(comment => (
                    <CommentItem
                        key={comment.commentId}
                        comment={comment}
                        objectTypeSelf={objectType}
                        objectIdSelf={objectId}
                        openEmailHistory={openEmailHistory}
                        setDispatch={setDispatch}
                        isDisabled={isDisabled}
                        onStateUpdate={onStateUpdate}
                        onDeleteComment={onDeleteComment}
                    />
                ))}
            {/* : (
       <p>No comments to display.</p>
       )} */}
        </div>
    );
};

export default CommentList;
